var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"accent-mark block",style:({
    width: _vm.width, 
    height: _vm.height,
    marginRight: _vm.marginX,
    marginLeft: _vm.marginX,
    marginTop: _vm.marginTop,
    marginBottom: _vm.marginBottom
})})}
var staticRenderFns = []

export { render, staticRenderFns }